export const ROUTES = {
  CHAMPIONSHIPS: 'competitions',
  RESTORE_PASSWORD: 'restore-password',
  SIGNUP: 'signup',
  CHANGE_PASSWORD: 'change-password',
  CUSTOM_EVENTS: 'custom-events',
  UPCOMING_GAMES: 'upcoming-games',
  POLICY: 'policy',
  PRIVACY: 'privacy',
  SUPPORT: 'support',
  VITALS: 'vitals',
  NEWS: 'news',
};
